import { render, staticRenderFns } from "./InputColor.vue?vue&type=template&id=b7b26aa8&scoped=true"
import script from "./InputColor.vue?vue&type=script&lang=js"
export * from "./InputColor.vue?vue&type=script&lang=js"
import style0 from "./InputColor.vue?vue&type=style&index=0&id=b7b26aa8&prod&scoped=true&lang=scss"
import style1 from "./InputColor.vue?vue&type=style&index=1&id=b7b26aa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b26aa8",
  null
  
)

export default component.exports